import { type ServiceAppState, TOKEN_SCOPE } from '@kc-console/context';
import { getConsoleBaseUrl, STATUS_CODE } from '@kc-console/core';

import { getRequestUrlData } from '../../utils/getRequestUrlData';

import type { Guard } from '../../types';

/**
 * 프로젝트 스콥 토큰을 소유한 사용자가 dashboard/welcome으로의 접근을 리다이렉트하는 Guard
 * @description
 * 해당 페이지를 보지 않아도 되는 사용자를 dashboard의 home 페이지로 리다이렉트합니다.
 * - 해당 페이지: dashboard 서비스의 welcome페이지
 * - 해당 페이지를 보지 않아도 되는 사용자: 유효한 projectId로 발급 받은 project-scope 토큰의 사용자
 */
export const checkUnscopeGuard: Guard<ServiceAppState> = async ({ state, context }) => {
  const { scope, serviceKeyword, projectId } = state;
  // unscope 페이지가 아니라면 필요없는 로직이므로 바로 가드 종료
  if (scope !== TOKEN_SCOPE.UNSCOPE) return { status: STATUS_CODE.OK };

  const { urlObj } = getRequestUrlData(context);

  if (serviceKeyword === 'dashboard' && projectId) {
    return {
      redirect: {
        destination: `${getConsoleBaseUrl(urlObj.origin)}/dashboard/home`,
        permanent: false,
      },
    };
  } else {
    return { status: STATUS_CODE.OK };
  }
};

checkUnscopeGuard.displayName = 'checkUnscopeGuard';
